// Çoklu siparişin alt siparişi için Faturalama İşlemleri. Sipariş Listesi'ndeki ana / ek sipariş faturalamasıyla
// aynı akış ve tasarım: E-Fatura Oluştur | E-Fatura Bağla, düzenlenebilir Fatura Bilgileri,
// taslakta Resmileştir | Önizleme | Kontrol | İptal Et, resmileşince e-fatura önizlemesi ve iptal geçmişi.
import React, { useState } from 'react';
import EditIcon from './assets/images/edit-icon.svg';
import CrossIconRed from './assets/images/cross_icon_red.svg';
import ParasutLogo from './assets/images/parasut_logo.svg';
import CheckIcon from './assets/images/kontrol.svg';
import UndoIcon from './assets/images/guncelle.svg';
import OnizlemeIcon from './assets/images/onizleme.svg';
import ResmilestirIcon from './assets/images/resmilestir.svg';
import FaturaOnizleme, { faturaPdfAl, islemButonStili, islemIkonu, parasutResmilestir, taslakOnizlemeAc } from './FaturaOnizleme';

const KAYDEDILMEMIS_UYARISI = 'Fatura bilgilerinde kaydedilmemiş değişiklik var. Lütfen önce Kaydet veya İptal ile düzenlemeyi tamamlayın.';

// altSiparis: fatura_bilgileri ve iptal_faturalar ile birlikte (backend _coklu_siparis_to_dict)
// faturaStatus: /api/faturalar/<id>/durum sonucu ({ is_finalized, iptal_edildi }) veya null (sorgulanıyor)
// onAltGuncelle(alanlar): alt siparişin yerel kaydını günceller; onYenile(): çoklu sipariş listesini yeniden yükler
export default function AltSiparisFaturalama({ altSiparis, faturaStatus, faturaDurumuSorgula, onAltGuncelle, onYenile, pasif, telefon }) {
    const API = process.env.REACT_APP_API_URL || '';
    const authHeaders = () => ({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` });
    const urlKoku = `${API}/api/coklu-siparisler/alt-siparisler/${altSiparis.id}`;
    const faturaId = altSiparis.parasut_fatura_id;
    const b = altSiparis.fatura_bilgileri;

    const [faturaForm, setFaturaForm] = useState(null); // düzenleme açıkken form değerleri
    const [faturaKaydediliyor, setFaturaKaydediliyor] = useState(false);
    const [taslakKontrol, setTaslakKontrol] = useState(null); // { durum: 'yukleniyor' | 'guncelleniyor' | 'hazir', sonuc }
    const [faturaBagla, setFaturaBagla] = useState(null); // { numara, bagliyor }
    const [islem, setIslem] = useState(null); // 'olustur' | 'resmilestir' | 'iptal' | 'onizleme'

    const kaydedilmemisVar = () => {
        if (!faturaForm) return false;
        alert(KAYDEDILMEMIS_UYARISI);
        return true;
    };

    // --- FATURA BİLGİLERİ ---
    const handleFaturaDuzenleBaslat = () => setFaturaForm({
        telefon: b.telefon || '',
        ad_soyad: b.ad_soyad || '',
        adres: b.adres || '',
        ilce: b.ilce || '',
        il: b.il || '',
        vergi_no: b.vergi_no || '',
        vergi_tipi: b.vergi_tipi || 'tc',
        vergi_dairesi: b.vergi_dairesi || ''
    });

    const handleFaturaBilgileriKaydet = async () => {
        if (!faturaForm.ad_soyad.trim()) {
            alert('Fatura ismi boş bırakılamaz.');
            return;
        }
        const vergiNo = faturaForm.vergi_no.replace(/\D/g, '');
        if (faturaForm.vergi_tipi === 'vergi') {
            if (vergiNo.length !== 10) {
                alert('Vergi No 10 haneli olmalıdır.');
                return;
            }
            if (!faturaForm.vergi_dairesi.trim()) {
                alert('Vergi No seçildiğinde Vergi Dairesi zorunludur.');
                return;
            }
        } else if (vergiNo && vergiNo.length !== 11) {
            alert('T.C. Kimlik No 11 haneli olmalıdır.');
            return;
        }
        setFaturaKaydediliyor(true);
        try {
            const response = await fetch(`${urlKoku}/fatura-bilgileri`, {
                method: 'PUT', headers: authHeaders(), body: JSON.stringify({ ...faturaForm, vergi_no: vergiNo })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            onAltGuncelle({ fatura_bilgileri: data.fatura_bilgileri });
            setFaturaForm(null);
            setTaslakKontrol(null); // eski karşılaştırma sonucu geçersiz
        } catch (error) {
            alert(`Fatura bilgileri kaydedilemedi:\n${error.message}`);
        } finally {
            setFaturaKaydediliyor(false);
        }
    };

    // --- E-FATURA OLUŞTUR / BAĞLA ---
    const handleFaturaOlustur = async () => {
        if (pasif || islem || kaydedilmemisVar()) return;
        if (!window.confirm(`"${b.ad_soyad}" adına Paraşüt'te fatura taslağı oluşturulacaktır. Emin misiniz?`)) return;
        setIslem('olustur');
        try {
            const res = await fetch(`${API}/api/coklu-siparisler/alt-siparis-fatura`, {
                method: 'POST', headers: authHeaders(), body: JSON.stringify({ alt_siparis_id: altSiparis.id })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.hata || 'Fatura oluşturulamadı');
            alert(`Fatura oluşturuldu!\nFatura ID: ${data.fatura_id}`);
            onYenile();
            faturaDurumuSorgula(data.fatura_id);
        } catch (err) {
            alert(`Fatura oluşturulamadı:\n${err.message}`);
        } finally {
            setIslem(null);
        }
    };

    const handleFaturaBagla = async () => {
        const numara = (faturaBagla?.numara || '').trim();
        if (!numara) { alert('Fatura numarası giriniz.'); return; }
        setFaturaBagla(prev => ({ ...prev, bagliyor: true }));
        try {
            const response = await fetch(`${urlKoku}/fatura-bagla`, {
                method: 'POST', headers: authHeaders(), body: JSON.stringify({ fatura_no: numara })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            alert(`✅ ${data.mesaj}`);
            setFaturaBagla(null);
            onYenile();
            faturaDurumuSorgula(data.faturaId);
        } catch (error) {
            alert(`Fatura bağlanamadı:\n${error.message}`);
            setFaturaBagla(prev => prev ? { ...prev, bagliyor: false } : prev);
        }
    };

    // --- TASLAK: RESMİLEŞTİR / ÖNİZLEME / KONTROL / İPTAL ---
    const taslakSonucunuIsle = (sonuc) => {
        // Resmileşme tespit edildiyse backend sabitlenen bilgileri döndürür
        if (sonuc.fatura_bilgileri) onAltGuncelle({ fatura_bilgileri: sonuc.fatura_bilgileri });
        if (sonuc.resmilesti) faturaDurumuSorgula(faturaId);
        setTaslakKontrol({ durum: 'hazir', sonuc });
    };

    const handleTaslakKontrol = async () => {
        if (kaydedilmemisVar()) return;
        setTaslakKontrol({ durum: 'yukleniyor', sonuc: null });
        try {
            const response = await fetch(`${urlKoku}/fatura-taslak-kontrol`, { headers: authHeaders() });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            taslakSonucunuIsle(data);
        } catch (error) {
            setTaslakKontrol({ durum: 'hazir', sonuc: { hata: error.message } });
        }
    };

    const handleTaslakGuncelle = async () => {
        if (!window.confirm('Listelenen değişiklikler Paraşüt\'teki taslak faturaya işlenecektir. Emin misiniz?')) return;
        setTaslakKontrol(prev => ({ ...prev, durum: 'guncelleniyor' }));
        try {
            const response = await fetch(`${urlKoku}/fatura-taslak-guncelle`, { method: 'POST', headers: authHeaders() });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            taslakSonucunuIsle(data);
        } catch (error) {
            setTaslakKontrol({ durum: 'hazir', sonuc: { hata: `Taslak güncellenemedi: ${error.message}` } });
        }
    };

    const handleResmilestir = async () => {
        if (pasif || islem || kaydedilmemisVar()) return;
        if (!window.confirm('Fatura resmileştirilecek ve alıcıya e-fatura / e-arşiv olarak düzenlenecek.\n\nBu işlem GERİ ALINAMAZ. Fatura bilgileri ve kalemleri doğru mu?')) return;
        setIslem('resmilestir');
        try {
            const sonuc = await parasutResmilestir(faturaId);
            alert(sonuc.devamEdiyor
                ? `${sonuc.belge_turu} işlemi Paraşüt'te devam ediyor. Birkaç dakika sonra sayfayı yenileyip kontrol edin.`
                : `✅ Fatura ${sonuc.belge_turu} olarak resmileştirildi.`);
            setTaslakKontrol(null);
            // Durum sorgusu resmileşen faturanın bilgilerini backend'de sabitler
            await faturaDurumuSorgula(faturaId);
            onYenile();
        } catch (error) {
            alert(`Resmileştirme hatası: ${error.message}`);
        } finally {
            setIslem(null);
        }
    };

    const handleTaslakOnizleme = async () => {
        setIslem('onizleme');
        try {
            await taslakOnizlemeAc(faturaId);
        } catch (error) {
            alert(`Fatura önizlemesi açılamadı:\n${error.message}`);
        } finally {
            setIslem(null);
        }
    };

    // Taslak (resmi=false) veya resmileşmiş faturayı iptal eder; alt sipariş E-Fatura Oluştur / Bağla aşamasına döner
    const handleFaturaIptal = async (resmi) => {
        if (pasif || islem || kaydedilmemisVar()) return;
        const soru = faturaStatus?.iptal_edildi
            ? 'Bu fatura Paraşüt\'te zaten iptal edilmiş.\n\nSistemde de iptal edilecek ve alt sipariş "E-Fatura Oluştur / E-Fatura Bağla" aşamasına dönecek. Emin misiniz?'
            : resmi
            ? 'Resmileşmiş fatura iptal edilecek.\n\nSadece son kullanıcı (11111111111) faturaları, fatura tarihinden itibaren 7 gün içinde iptal edilebilir.\n\nBu işlem GERİ ALINAMAZ. Emin misiniz?'
            : 'Fatura taslağı Paraşüt\'ten silinerek iptal edilecek ve alt sipariş "E-Fatura Oluştur / E-Fatura Bağla" aşamasına dönecek.\n\nEmin misiniz?';
        if (!window.confirm(soru)) return;
        setIslem('iptal');
        try {
            const response = await fetch(`${API}/api/faturalar/${faturaId}/iptal`, { method: 'POST', headers: authHeaders() });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            alert(`✅ ${data.mesaj}`);
            setTaslakKontrol(null);
            onYenile();
        } catch (error) {
            alert(`Fatura iptal edilemedi:\n${error.message}`);
        } finally {
            setIslem(null);
        }
    };

    const handleFaturaIndir = async () => {
        try {
            const sonuc = await faturaPdfAl(faturaId);
            if (sonuc.resmilesmemis) throw new Error('Bu fatura henüz resmileşmemiş.');
            const url = window.URL.createObjectURL(new Blob([sonuc.veri], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.download = `fatura_${sonuc.faturaNo || faturaId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            alert(`PDF indirilemedi: ${err.message}`);
        }
    };

    // Fatura kesilmemişken: E-Fatura Oluştur | E-Fatura Bağla (bağlamada fatura numarası sorulur)
    const renderFaturaOlusturBagla = () => {
        const baglaAcik = !!faturaBagla;
        const butonPasif = pasif || !!islem;
        const butonStili = {
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flex: 1, minWidth: 0,
            padding: '10px', cursor: butonPasif ? 'not-allowed' : 'pointer', fontFamily: 'poppins', background: '#f8f8f8',
            border: '1px solid #ccc', borderRadius: '4px', opacity: butonPasif ? '0.5' : '1', whiteSpace: 'nowrap'
        };
        const kucukButon = { padding: '5px 14px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', background: '#f8f8f8', fontFamily: 'Poppins, sans-serif', cursor: faturaBagla?.bagliyor ? 'wait' : 'pointer' };
        return (
            <div style={{ marginBottom: '15px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button style={butonStili} disabled={butonPasif} onClick={handleFaturaOlustur}>
                        <img src={ParasutLogo} alt="E-Fatura Oluştur" style={{ height: '16px' }} />
                        <span>{islem === 'olustur' ? 'Oluşturuluyor...' : 'E-Fatura Oluştur'}</span>
                    </button>
                    <button style={{ ...butonStili, ...(baglaAcik ? { background: '#e9ecef', borderColor: '#999' } : {}) }} disabled={butonPasif}
                        title="Paraşüt'te doğrudan kesilmiş faturayı fatura numarasıyla bu alt siparişe bağla"
                        onClick={() => {
                            if (butonPasif || kaydedilmemisVar()) return;
                            setFaturaBagla(baglaAcik ? null : { numara: '', bagliyor: false });
                        }}>
                        <img src={ParasutLogo} alt="E-Fatura Bağla" style={{ height: '16px' }} />
                        <span>E-Fatura Bağla</span>
                    </button>
                </div>
                {baglaAcik && (
                    <div style={{ marginTop: '8px', border: '1px solid #eee', borderRadius: '4px', background: '#f9f9f9', padding: '10px', fontFamily: 'Poppins, sans-serif' }}>
                        <label style={{ fontSize: '12px', fontWeight: '600', display: 'block', margin: '0 0 4px 0', color: '#333' }}>Fatura numarası giriniz</label>
                        <input type="text" autoFocus value={faturaBagla.numara} disabled={faturaBagla.bagliyor}
                            placeholder="Ör. SYP2026000000123"
                            onChange={(e) => setFaturaBagla(prev => ({ ...prev, numara: e.target.value }))}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleFaturaBagla(); if (e.key === 'Escape') setFaturaBagla(null); }}
                            style={{ width: '100%', padding: '5px 8px', border: '1px solid #ccc', borderRadius: '3px', fontSize: '13px', fontFamily: 'Poppins, sans-serif', boxSizing: 'border-box' }} />
                        <p style={{ fontSize: '11px', margin: '4px 0 8px 0', color: '#666' }}>
                            Paraşüt'teki fatura numarası (veya fatura sayfasının bağlantısı) girilebilir.
                        </p>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button style={kucukButon} disabled={faturaBagla.bagliyor} onClick={() => setFaturaBagla(null)}>Vazgeç</button>
                            <button style={kucukButon} disabled={faturaBagla.bagliyor} onClick={handleFaturaBagla}>
                                {faturaBagla.bagliyor ? 'Bağlanıyor...' : 'Bağla'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // Fatura kesilmiş ama resmileşmemişken: Resmileştir | Önizleme | Kontrol | İptal Et; kontrol sonucu altta
    const renderTaslakIslemleri = () => {
        const mesgul = taslakKontrol && taslakKontrol.durum !== 'hazir';
        const sonuc = taslakKontrol?.durum === 'hazir' ? taslakKontrol.sonuc : null;
        const resmilestirPasif = pasif || !!islem || !faturaStatus;
        const kontrolPasif = pasif || mesgul || islem === 'iptal';
        const iptalPasif = pasif || !!islem || mesgul;
        const onizlemePasif = !!islem;
        return (
            <div style={{ fontFamily: 'Poppins, sans-serif' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <button type="button" style={islemButonStili(resmilestirPasif, islem === 'resmilestir')} disabled={resmilestirPasif}
                        onClick={handleResmilestir}
                        title={!faturaStatus ? 'Fatura durumu kontrol ediliyor...' : 'Faturayı resmileştir (e-fatura / e-arşiv)'}>
                        {islemIkonu(ResmilestirIcon, '')}
                        <span>{islem === 'resmilestir' ? 'Resmileştiriliyor...' : 'Resmileştir'}</span>
                    </button>
                    <button type="button" style={islemButonStili(onizlemePasif, islem === 'onizleme')} disabled={onizlemePasif}
                        onClick={handleTaslakOnizleme}
                        title="Faturanın Paraşüt önizlemesini aç (resmileştirmeden)">
                        {islemIkonu(OnizlemeIcon, '')}
                        <span>{islem === 'onizleme' ? 'Açılıyor...' : 'Önizleme'}</span>
                    </button>
                    <button type="button" style={islemButonStili(kontrolPasif, mesgul)} disabled={kontrolPasif}
                        onClick={handleTaslakKontrol}
                        title="Taslağı alt siparişin güncel haliyle karşılaştır">
                        {islemIkonu(CheckIcon, '')}
                        <span>{taslakKontrol?.durum === 'yukleniyor' ? 'Kontrol...' : 'Kontrol'}</span>
                    </button>
                    <button type="button" style={islemButonStili(iptalPasif, islem === 'iptal')} disabled={iptalPasif}
                        onClick={() => handleFaturaIptal(false)}
                        title="Fatura taslağını iptal et">
                        <img src={CrossIconRed} alt="" style={{ height: '22px', margin: '0 -3px' }} />
                        <span>{islem === 'iptal' ? 'İptal ediliyor...' : 'İptal Et'}</span>
                    </button>
                </div>

                {taslakKontrol?.durum === 'guncelleniyor' && (
                    <p style={{ fontSize: '12px', color: '#666', margin: '8px 0 0 0' }}>Taslak fatura güncelleniyor...</p>
                )}
                {sonuc && (
                    <div style={{ marginTop: '8px', border: '1px solid #eee', borderRadius: '4px', background: '#fff', padding: '10px', fontSize: '12px' }}>
                        {sonuc.hata ? (
                            <p style={{ margin: 0, color: '#dc3545' }}>{sonuc.hata}</p>
                        ) : sonuc.resmilesti ? (
                            <p style={{ margin: 0, color: '#666' }}>{sonuc.mesaj || 'Fatura resmileştiği için güncellenemez.'}</p>
                        ) : (sonuc.farklar || []).length === 0 ? (
                            <p style={{ margin: 0, color: '#28a745', fontWeight: '600' }}>
                                {sonuc.mesaj === 'Taslak fatura güncellendi.' ? 'Taslak fatura güncellendi, ' : ''}Taslak, alt siparişin güncel haliyle aynı.
                            </p>
                        ) : (
                            <>
                                <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: '#c0392b' }}>{sonuc.mesaj}</p>
                                {sonuc.farklar.map((f, i) => (
                                    <div key={i} style={{ padding: '5px 0', borderTop: i ? '1px solid #f2f2f2' : 'none' }}>
                                        <div style={{ fontWeight: '600', color: '#333' }}>{f.alan}</div>
                                        <div style={{ color: '#888', textDecoration: 'line-through' }}>{f.mevcut || '—'}</div>
                                        <div style={{ color: '#1565C0' }}>{f.yeni || '—'}</div>
                                    </div>
                                ))}
                                <button type="button" style={{ ...islemButonStili(kontrolPasif, mesgul), marginTop: '8px' }} disabled={kontrolPasif}
                                    onClick={handleTaslakGuncelle}
                                    title="Listelenen değişiklikleri Paraşüt'teki taslağa işle">
                                    {islemIkonu(UndoIcon, '')}
                                    <span>Güncelle</span>
                                </button>
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    };

    // Fatura Bilgileri paneli; duzenlenebilir=false ise (fatura resmileşmişse) sadece gösterilir
    const renderFaturaBilgileri = (duzenlenebilir, faturaVar = false) => {
        if (!b) return null;
        const aktif = duzenlenebilir && !!faturaForm;
        const degerler = aktif ? faturaForm : b;
        const degisenler = duzenlenebilir ? (b.degistirilen_alanlar || []) : [];
        const alanStili = {
            width: '100%', padding: '5px 8px', border: '1px solid #ccc', borderRadius: '3px', fontSize: '13px',
            fontFamily: 'Poppins, sans-serif', boxSizing: 'border-box',
            backgroundColor: aktif ? 'white' : '#f1f1f1', color: aktif ? '#000' : '#555'
        };
        const etiketStili = { fontSize: '12px', fontWeight: '600', display: 'block', margin: '0 0 3px 0', color: '#333' };
        const degisti = (alan) => !aktif && degisenler.includes(alan) && (
            <span title="Varsayılan bilgiden farklı" style={{ color: '#1565C0', fontWeight: '500', marginLeft: '5px' }}>(değiştirildi)</span>
        );
        const guncelle = (alan) => (e) => setFaturaForm(prev => ({ ...prev, [alan]: e.target.value }));
        const butonStili = {
            padding: '5px 14px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', background: '#f8f8f8',
            fontFamily: 'Poppins, sans-serif', cursor: faturaKaydediliyor ? 'wait' : 'pointer'
        };

        return (
            <div style={{ marginBottom: '15px', border: '1px solid #eee', padding: '12px', borderRadius: '4px', background: '#f9f9f9' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#333' }}>Fatura Bilgileri</h4>
                    {duzenlenebilir && !faturaForm && !pasif && (
                        <img src={EditIcon} alt="Düzenle" title="Fatura bilgilerini düzenle"
                            onClick={handleFaturaDuzenleBaslat}
                            style={{ height: '16px', cursor: 'pointer' }} />
                    )}
                </div>

                <div style={{ marginBottom: '8px' }}>
                    <label style={etiketStili}>Telefon Numarası{degisti('telefon')}</label>
                    <input type="text" value={degerler.telefon} disabled={!aktif} onChange={guncelle('telefon')} style={alanStili} />
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <label style={etiketStili}>İsim / Ünvan{degisti('ad_soyad')}</label>
                    <input type="text" value={degerler.ad_soyad} disabled={!aktif} onChange={guncelle('ad_soyad')} style={alanStili} />
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <label style={etiketStili}>Adres{(degisti('adres') || degisti('ilce') || degisti('il'))}</label>
                    <textarea value={degerler.adres} disabled={!aktif} onChange={guncelle('adres')} rows={2}
                        style={{ ...alanStili, resize: 'vertical', marginBottom: '5px' }} />
                    <div style={{ display: 'flex', gap: '5px' }}>
                        <input type="text" placeholder="İlçe" value={degerler.ilce} disabled={!aktif} onChange={guncelle('ilce')} style={alanStili} />
                        <input type="text" placeholder="İl" value={degerler.il} disabled={!aktif} onChange={guncelle('il')} style={alanStili} />
                    </div>
                </div>
                <div style={{ marginBottom: aktif ? '12px' : 0 }}>
                    {/* T.C. Kimlik No (11 hane) / Vergi No (10 hane + vergi dairesi) seçimi */}
                    <div style={{ display: 'flex', gap: '6px', marginBottom: '5px' }}>
                        {[['tc', 'T.C. Kimlik No'], ['vergi', 'Vergi No']].map(([tip, etiket]) => {
                            const secili = (degerler.vergi_tipi || 'tc') === tip;
                            return (
                                <button key={tip} type="button" disabled={!aktif}
                                    onClick={() => setFaturaForm(prev => ({
                                        ...prev,
                                        vergi_tipi: tip,
                                        // Tip değişince numara diğer tipe uymaz: T.C.'de varsayılan, Vergi'de boş başlar
                                        vergi_no: tip === prev.vergi_tipi ? prev.vergi_no : (tip === 'tc' ? '11111111111' : ''),
                                        vergi_dairesi: tip === 'tc' ? '' : prev.vergi_dairesi
                                    }))}
                                    style={{
                                        flex: 1, padding: '4px 8px', fontSize: '12px', fontFamily: 'Poppins, sans-serif',
                                        fontWeight: secili ? '600' : '400', border: '1px solid #ccc', borderRadius: '3px',
                                        background: secili ? '#1565C0' : (aktif ? 'white' : '#f1f1f1'),
                                        color: secili ? 'white' : '#555',
                                        cursor: aktif ? 'pointer' : 'default',
                                        opacity: !aktif && !secili ? 0.6 : 1
                                    }}>
                                    {etiket}
                                </button>
                            );
                        })}
                    </div>
                    <label style={etiketStili}>
                        {(degerler.vergi_tipi || 'tc') === 'vergi' ? 'Vergi No (10 hane)' : 'T.C. Kimlik No (11 hane)'}{degisti('vergi_no')}
                    </label>
                    <input type="text" inputMode="numeric"
                        maxLength={(degerler.vergi_tipi || 'tc') === 'vergi' ? 10 : 11}
                        value={degerler.vergi_no} disabled={!aktif} onChange={guncelle('vergi_no')} style={alanStili} />
                    {(degerler.vergi_tipi || 'tc') === 'vergi' && (
                        <div style={{ marginTop: '8px' }}>
                            <label style={etiketStili}>Vergi Dairesi{degisti('vergi_dairesi')}</label>
                            <input type="text" value={degerler.vergi_dairesi || ''} disabled={!aktif} onChange={guncelle('vergi_dairesi')} style={alanStili} />
                        </div>
                    )}
                </div>

                {aktif && (
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                        <button onClick={() => setFaturaForm(null)} disabled={faturaKaydediliyor} style={butonStili}>İptal</button>
                        <button onClick={handleFaturaBilgileriKaydet} disabled={faturaKaydediliyor} style={butonStili}>
                            {faturaKaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
                        </button>
                    </div>
                )}
                {!duzenlenebilir && (
                    <p style={{ fontSize: '11px', margin: '8px 0 0 0', color: '#666' }}>
                        Fatura resmileştiği için bilgiler değiştirilemez.
                    </p>
                )}
                {duzenlenebilir && faturaVar && !aktif && (
                    <p style={{ fontSize: '11px', margin: '8px 0 0 0', color: '#666' }}>
                        Fatura taslağı Paraşüt'te. Bilgileri değiştirdikten sonra "Kontrol" ve "Güncelle" ile taslağa işleyebilirsiniz.
                    </p>
                )}
            </div>
        );
    };

    // İptal edilen faturaların geçmişi (fatura bölümünün altında her zaman gösterilir)
    const iptalGecmisi = altSiparis.iptal_faturalar || [];

    return (
        <div style={{ fontFamily: 'Poppins, sans-serif' }}>
            {!faturaId ? (
                <div>
                    {renderFaturaOlusturBagla()}
                    {renderFaturaBilgileri(true)}
                </div>
            ) : faturaStatus?.is_finalized ? (
                /* Resmileşmiş: Gönder | İndir | Yazdır | İptal Et ve e-fatura önizlemesi */
                <FaturaOnizleme
                    faturaId={faturaId}
                    onIndir={handleFaturaIndir}
                    telefon={telefon}
                    onIptal={pasif ? null : () => handleFaturaIptal(true)}
                    iptalEdiliyor={islem === 'iptal'}
                    iptalEdildi={!!faturaStatus?.iptal_edildi}
                />
            ) : (
                <>
                    {!b?.sabit && renderTaslakIslemleri()}
                    <div style={{ marginTop: '15px' }}>
                        {renderFaturaBilgileri(!b?.sabit, true)}
                    </div>
                </>
            )}
            {iptalGecmisi.length > 0 && (
                <div style={{ marginTop: '10px', fontSize: '12px' }}>
                    {iptalGecmisi.map((f, i) => (
                        <div key={`${f.fatura_id}-${i}`} style={{ padding: '6px 10px', marginTop: i ? '4px' : 0, border: '1px solid #f5c2c7', background: '#fdecee', color: '#842029', borderRadius: '4px' }}>
                            {f.tur === 'resmi'
                                ? `${f.fatura_no || f.fatura_id} nolu fatura iptal edildi.`
                                : `${f.fatura_id} nolu fatura taslağı iptal edildi.`}
                            <span style={{ color: '#888', marginLeft: '6px' }}>{f.tarih}{f.kullanici ? ` · ${f.kullanici}` : ''}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
